//
import Vue from 'vue'
import axios from 'axios'
import { Model } from 'vue-api-query'
import VueBarcodeScanner from 'vue-barcode-scanner'
import './plugins/vuetify'

//
import colors from '@/mixins/Colors'
import SnackbarModalUtils from '@/mixins/reusable_mixins/SnackbarModalUtils'
import { beforeRequest, errorRequest } from '@/services/InterceptorAxios'

//
import App from './app'
import router from './routes/router'
import store from './store/store'
import toaster from './plugins/toaster'

// fetch the local user token
const userToken = localStorage.getItem('user-token')

// set default axios headers
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = userToken || ''

// set request and response axios interceptor
axios.interceptors.request.use(beforeRequest, undefined)
axios.interceptors.response.use(undefined, errorRequest)

import { permissions } from './mixins/reusable_mixins'
Vue.mixin(permissions)

// set axios with app models
Model.$http = axios

// set production tip
Vue.config.productionTip = false

// set global plugins
Vue.use(axios)
Vue.use(toaster)
Vue.use(VueBarcodeScanner)

// set global mixins
Vue.mixin(SnackbarModalUtils)
Vue.mixin({
    data: function() {
        return {
            colors: colors,
        }
    },
})

// render app
new Vue({ router, store, render: h => h(App) }).$mount('#app')
